// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3540":"cbcaf828","4351":"b74bcf10","4722":"45eebc78","4967":"f73e7d62","5492":"fdc1dab3","6003":"615523ec","6977":"cbcaf828","7977":"fdc1dab3","8033":"60ed0781","9523":"b65a9c96","9534":"615523ec","9673":"615523ec"}[chunkId] + ".chunk.css";
};